import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/**
 * ### **SectionHeading**
 *
 * Encabezado de seccion del home: antetitulo, titulo y un enlace opcional "Ver todo".
 *
 * El `headingId` es obligatorio porque cada `<section>` se etiqueta con
 * `aria-labelledby` apuntando a este titulo.
 */
@Component({
  selector: 'app-section-heading',
  imports: [],
  templateUrl: './section-heading.component.html',
  styleUrl: './section-heading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHeading {
  /** Antetitulo en mayusculas sobre el titulo. */
  readonly eyebrow = input.required<string>();

  /** Titulo de la seccion. */
  readonly title = input.required<string>();

  /** Id del `<h2>`, referenciado por el `aria-labelledby` de la seccion. */
  readonly headingId = input.required<string>();

  /** Muestra el enlace "Ver todo" a la derecha del titulo. */
  readonly showViewAll = input(false);

  /** Emite al pulsar "Ver todo". */
  readonly viewAll = output<void>();
}
